// extracted by mini-css-extract-plugin
export default {"formContentLeft":"SuccessDark_formContentLeft__2M6rw","formImg2":"SuccessDark_formImg2__AqtRx","formHeader":"SuccessDark_formHeader__Vc4-z","formDesc":"SuccessDark_formDesc__3jls0"};